import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Pane, TriangleIcon, Text, Tooltip, colors } from 'evergreen-ui'

const getTooltipForType = type => {
  switch (type) {
    case 'success':
      return 'This event has been received in the last 24 hours, making it a strong event for your audience.'
    case 'danger':
      return 'This event has not been active in the past 30 days, making it a weak event for your audience.'
    case 'warning':
      return 'This event has been received in the past 30 days, making it a good event for your audience.'
    default:
      return ''
  }
}

const getColorForType = type => {
  switch (type) {
    case 'success':
      return colors.green['500']
    case 'danger':
      return colors.red['500']
    case 'warning':
      return colors.yellow['500']
    default:
      return colors.blue['500']
  }
}

export default class Group extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    style: PropTypes.any,
    height: PropTypes.number,
    status: PropTypes.oneOf(['success', 'warning', 'danger']),
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func
  }

  render() {
    const { label, style, height, status, isOpen, onToggle } = this.props

    return (
      <Pane
        style={style}
        height={height}
        appearance="tint2"
        display="flex"
        alignItems="center"
        borderBottom="extraMuted"
        cursor="pointer"
        onClick={onToggle}
      >
        <Pane flex="1" display="flex" alignItems="center">
          <TriangleIcon
            aim={isOpen ? 'up' : 'down'}
            width={28}
            iconWidth={12}
          />

          <Text isUppercase size={200} fontWeight={600} color="muted">
            {label}
          </Text>
        </Pane>

        <Tooltip content={getTooltipForType(status)}>
          <Pane
            width={6}
            height={6}
            borderRadius="50%"
            backgroundColor={getColorForType(status)}
            marginRight={8}
          />
        </Tooltip>
      </Pane>
    )
  }
}
